<template>
  <div class="article-wrapper">
    <div class="clearfix">
      <Form @submit.native.prevent :model="formData" label-position="left">
        <FormItem label="用户昵称:" class="fl mytable-title" :label-width="72">
          <Input v-model="formData.username"></Input>
        </FormItem>
        <FormItem label="手机号:" class="fl mytable-title" :label-width="72">
          <Input v-model="formData.phone"></Input>
        </FormItem>
        <div class="fl checkReset">
          <Button type="primary" class="fl" @click="handleQuery">查询</Button>
          <Button class="fl" @click="handleReset">重置</Button>
        </div>
        <div class="money-box">
          <span class="money-item money-all">
            兑换总额
            <b>¥{{ext.cash_money?ext.cash_money:0}}</b>
          </span>
          <span class="money-item" v-for="(item,index) in cashList" :key="index">
            {{item}}元
            <b>{{ext[item]?ext[item]:0}}张</b>
          </span>
        </div>
        <div class="clearfix"></div>
        <div class="line mb20"></div>
        <FormItem label class="fl mytable-title" :label-width="0">
          <RadioGroup
            v-model.trim="formData.cash_money"
            type="button"
            class="mr20"
            @on-change="handleQuery"
          >
            <Radio :label="null">全部</Radio>
            <Radio :label="item" v-for="(item,index) in cashList" :key="index">{{item}}元</Radio>

            <Radio :label="999" style="margin-left:30px;">抽奖</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="日期范围:" class="fl mytable-title" :label-width="72">
          <DatePicker
            class="w240"
            v-model.trim="date"
            type="daterange"
            @on-change="handleDateChange"
            format="yyyy-MM-dd"
            placeholder="开始日期 ~ 结束日期"
          ></DatePicker>
        </FormItem>
      </Form>
      <div class="fr red">友情提示：当前数据统计有一分钟左右延时</div>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    />
  </div>
</template>

<script>
import timeMixin from "@/mixins/time";
import articleOrder from "@/components/articleOrder";
import mixins from "@/mixins/page";
import refundModal from "@/components/refundModal.vue";
import { getCookie } from "../../libs/util";
export default {
  name: "article_manage",
  mixins: [mixins],
  components: {
    articleOrder,
    refundModal
  },
  data() {
    return {
      date: [],
      tableData: [],
      formData: {
        cash_money: null
      },
      formData1: {
        cash_money: null
      },
      cashList: [],
      ext: {},
      columns: [
        {
          title: "用户昵称",
          key: "username",
          minWidth: 130
        },
        {
          title: "用户头像",
          key: "poster",
          minWidth: 80,
          render: (h, params) => {
            return h("img", {
              class: {
                table_pic: true
              },
              domProps: {
                src: params.row.poster
              }
            });
          }
        },
        {
          title: "手机号",
          key: "phone",
          minWidth: 100,
          render: (h, params) => {
            var phone = params.row.phone
              ? params.row.phone.substr(0, 3) +
                "****" +
                params.row.phone.substr(7)
              : "无";
            return h("span", phone);
          }
        },
        {
          title: "兑换总额",
          key: "cash_money",
          minWidth: 100
        },
        {
          title: "消耗积分",
          key: "integral",
          minWidth: 100
        },
        {
          title: "兑换时间",
          key: "create_time",
          width: 140
        }
      ]
    };
  },
  mounted() {
    // this.getcashCouponList()
    this.getAllCoupons();
    this.handleQuery();
  },
  methods: {
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.formData.create_time_start = val[0] + " 00:00:00";
        this.formData.create_time_end = val[1] + " 23:59:59";
      } else {
        this.formData.create_time_start = null;
        this.formData.create_time_end = null;
      }
      this.handleQuery();
    },
    getAllCoupons() {
      this.$api.getAllCoupons({}).then(res => {
        let columnsArr = [];
        this.cashList = res.data.map(v => {
          columnsArr.push({
            title: v.cash_money + "元",
            key: v.cash_money,
            minWidth: 100
          });
          return v.cash_money;
        });
        this.columns = this.columns.reduce((prev, cur) => {
          if (cur.key == "phone") {
            return prev.concat(columnsArr).concat([cur]);
          } else {
            return prev.concat([cur]);
          }
        }, []);
      });
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      let param = {
        page_num: this.page_num,
        page_size: this.page_size,
        ...this.formData
      };
      this.$api.cashCouponDetails(param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.list ? res.data.list : [];
          this.ext = res.data.ext;
          this.total = res.data.total_row;
          this.tableLoading = false;
        }
      });
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.date = [];
      this.handleQuery();
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
.input100 {
  width: 110px;
}
.input122 {
  width: 122px;
}
.money-box {
  display: inline-block;
  float: right;
  .money-all {
    b {
      color: #f21646 !important;
    }
  }
  .money-item {
    font-size: 14px;
    color: #2e3133;
    margin-right: 24px;
    &:last-child {
      margin-right: 0;
    }
    b {
      color: #1890ff;
      margin-left: 4px;
    }
  }
}
</style>
